export const PHONE_COUNTRY_CODE = '+90';

export function sanitizeNationalPhoneInput(value: string): string {
  return value.replace(/\D/g, '').slice(0, 10);
}

export function toNationalPhoneNumber(phone: string | null | undefined): string {
  if (!phone) return '';

  const digits = phone.replace(/\D/g, '');
  if (digits.startsWith('90')) return digits.slice(2);
  if (digits.startsWith('0')) return digits.slice(1);
  return digits;
}

export function toInternationalPhoneNumber(national: string): string {
  const digits = sanitizeNationalPhoneInput(national);
  if (!digits) return '';
  return `${PHONE_COUNTRY_CODE}${digits}`;
}

export function validateInternationalPhone(phone: string): string | null {
  if (!phone) return null;
  if (phone.length < 7 || phone.length > 30) {
    return 'Telefon numarası geçersiz.';
  }
  return null;
}
